import React, { useState, useEffect } from "react";

import { Button, Label } from "reactstrap";

import { Row, Col } from "reactstrap";

import { useUpdateCrmLeadByIdMutation } from "features/banking/BankingApiSlice";

import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
  useGetBlockByDistrictQuery,
} from "services/locationApiSlice";

import Select from "react-select";

import "react-loading-skeleton/dist/skeleton.css";

import CustomTextField from "components/CustomTextField";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import {
  useGetCrmBankingDocumentsByIdQuery,
  useUpdateFarmerByIdMutation,
  useUploadMediaFarmerMutation,
} from "features/onboarding/users/farmer/farmerApiSlice";
import { toast } from "react-toastify";
import { store } from "app/store";
import axios from "axios";
import { API_URL } from "app/config";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
const formatToYYYYMMDD = (dateStr) => {
  if (!dateStr) return "";

  dateStr = dateStr.trim();

  // Check if already yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

  // Try to match mm-dd-yyyy or dd-mm-yyyy
  const parts = dateStr.split(/[-\/]/); // split by - or /
  if (parts.length === 3) {
    let yyyy, mm, dd;

    // Detect format based on first part
    if (parts[0].length === 4) {
      // yyyy-mm-dd
      [yyyy, mm, dd] = parts;
    } else {
      // assume dd-mm-yyyy (common in your data)
      [dd, mm, yyyy] = parts;
    }

    // Trim each part and pad
    yyyy = yyyy.trim();
    mm = String(mm.trim()).padStart(2, "0");
    dd = String(dd.trim()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  // Fallback: try Date parsing
  const parsedDate = new Date(dateStr);
  if (isNaN(parsedDate.getTime())) return "";

  const yyyy = parsedDate.getFullYear();
  const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const dd = String(parsedDate.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};
const normalizeGender = (gender) => {
  if (!gender) return "";
  const g = gender.toLowerCase();
  if (g === "male") return "Male";
  if (g === "female") return "Female";
  if (g === "other" || g === "others") return "Other";
  return "";
};
const CrmEditLead = ({
  leadDetails,
  refetch,
  LeadsDataGetId,
  hideLeadEditModal, setCattleData,cattleData,  Isproposal,setIsProposal,setDetailsModal
}) => {
  const [stateIdEdit, setStateIdEdit] = useState("");
  // const cattleAddedDetails =
  //   LeadsDataHalf?.lead_details[0]?.service_details?.cattle_data;
  // console.log("cattleAddedDetails", cattleAddedDetails);
  const [districtIdEdit, setDistrictIdEdit] = useState("");
  const [blockIdEdit, setBlockIdEdit] = useState("");
  const [stateNameEdit, setStateNameEdit] = useState("");
  const [districtNameEdit, setDistrictNameEdit] = useState("");
  const [blockNameEdit, setBlockNameEdit] = useState("");
  const [cattleAddedDetails, setcattleAddedDetails] = useState(
    LeadsDataGetId?.lead_details[0]?.service_details?.cattle_data
  );
  // console.log("all cattle ", cattleAddedDetails);
  const [uploadMedia] = useUploadMediaFarmerMutation();
  const id = LeadsDataGetId?.user_id;
  const {
    data: documents,
    refetch: refetchDocuments,
  } = useGetCrmBankingDocumentsByIdQuery(id, {
    skip: !id,
  });
  // console.log("documents", documents);

  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateIdEdit, {
    skip: !stateIdEdit,
  });
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtIdEdit, {
    skip: !districtIdEdit,
  });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(false);
  const [updateCrmLead] = useUpdateCrmLeadByIdMutation();
  const [updateFarmer] = useUpdateFarmerByIdMutation();

  const [PincodeValue, setPincode] = useState("");
  const [PincodeDataList, setPincodeDataList] = useState([]);
  const [residentialPinState, setresidentialPinState] = useState("Pincode");

  const [loading, setLoading] = useState(false);
  const [editModel, setLeadEditModal] = useState(false);
  const [LeadsDataHalf, setLeadsDataHalf] = useState([]);
  const [leadDataEdit, setLeadDataEdit] = useState({
    first_name: leadDetails.first_name,
    last_name: leadDetails.last_name,
    lead_source: leadDetails.lead_source,
    primary_occupation: leadDetails.primary_occupation,
    email: leadDetails.email,
    phone_number: leadDetails.phone_number,
    DOB: leadDetails.DOB,

    gender: normalizeGender(leadDetails.gender),
    service_name: "Insurance",
    product_name: leadDetails?.product_name,
    pincode: leadDetails.pincode,
    address: leadDetails.address,
  });
  const [kycUploaded, setKycUploaded] = useState([]);
  const [proposalUploaded, setProposalUploaded] = useState([]);
  const [paymentUploaded, setPaymentUploaded] = useState([]);
  const [cattleUploaded, setCattleUploaded] = useState([]);
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [overlayUrl, setOverlayUrl] = useState("");
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [showSpinner, setSpinner] = useState(false);
  // const [cattleData, setCattleData] = useState([]);
  // const[Isproposal,setIsProposal]=useState(false)
  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [getStates]);

  useEffect(() => {
    setresidentialPinState(
      leadDetails.allData.pincode ? "Pincode" : "StateLevel"
    );
    setPincode(leadDetails.allData.pincode);
    setStateIdEdit(leadDetails.allData.state_code);
    setDistrictIdEdit(leadDetails.allData?.district_code);
    setBlockIdEdit(leadDetails.allData.block_code);
    setStateNameEdit(leadDetails.allData.state_name);
    setDistrictNameEdit(leadDetails.allData.district_name);
    setBlockNameEdit(leadDetails.allData.block_name);
  }, [leadDetails]);
  useEffect(() => {
    const kycDocs = documents?.data?.find(
      (d) => d?.document_category?.toLowerCase() === "kyc documents"
    );
    const proposalDocs = documents?.data?.find(
      (d) => d?.document_category?.toLowerCase() === "proposal form"
    );
    const paymentDocs = documents?.data?.find(
      (d) => d?.document_category?.toLowerCase() === "payment detail"
    );
    const cattleDocs = documents?.data?.find(
      (d) => d?.document_category?.toLowerCase() === "cattle documents"
    );
    setKycUploaded(kycDocs?.document_types);
    setProposalUploaded(proposalDocs?.document_types[0]?.documents || []);
    setPaymentUploaded(paymentDocs?.document_types || []);
    setCattleUploaded(cattleDocs?.document_types);
  }, [documents]);
  const handleChangeEditLead = (event) => {
    setLeadDataEdit({
      ...leadDataEdit,
      [event.target.name]: event.target.value,
    });
  };
  const refetchLeadsData = async (id) => {
    const state = store.getState();
    try {
      const getLeadsData = await axios.get(
        `${API_URL}/api/v1/crm/leads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (getLeadsData?.data) {
        setLeadsDataHalf(getLeadsData?.data?.data);
        setcattleAddedDetails(
          getLeadsData?.data?.data?.lead_details[0]?.service_details
            ?.cattle_data
        );
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
    }
  };
  useEffect(() => {
    refetchLeadsData(LeadsDataGetId?.id);
  }, [LeadsDataGetId]);

  // const updatedLeadDetails = LeadsDataHalf.lead_details.map((lead) => {
  //   console.log("cattleData leda data",cattleData)
  //   if (lead.service_details?.product_name === "Cattle") {
  //     return {
  //       ...lead,
  //       service_details: {
  //         ...lead.service_details,
  //         cattle_data: cattleData,
  //         num_cattle: cattleData.length,
  //       },
  //     };
  //   }
  //   console.log("lead",lead)
  //   return lead;
  // });
  const updatedLeadDetail = (cattleData) => {
    return LeadsDataHalf?.lead_details.map((lead) => {
      if (lead?.service_details?.product_name?.toLowerCase() === "cattle") {
        return {
          ...lead,
          service_details: {
            ...lead.service_details,
            cattle_data: cattleData,
            num_cattle: cattleData.length,
          },
        };
      }
      return lead; 
    });
  };
  const updatedSingleCattle = (cattleToUpdate) => {
  return LeadsDataHalf?.lead_details.map((lead) => {
    if (lead?.service_details?.product_name?.toLowerCase() === "cattle") {
      // Get existing cattle data
      const existingCattle = lead.service_details.cattle_data || [];

      // Check if this cattle already exists in the array
      const isAlreadyPresent = existingCattle.some(
        (c) => c.cattle_id === cattleToUpdate.cattle_id
      );

      // If not present, add it
      const newCattleData = isAlreadyPresent
        ? existingCattle
        : [...existingCattle, cattleToUpdate];

      return {
        ...lead,
        service_details: {
          ...lead.service_details,
          cattle_data: newCattleData,
          num_cattle: newCattleData.length,
        },
      };
    }
    return lead;
  });
};

  const onSubmitLeadEditData = (e) => {
    e.preventDefault();
    console.log("cattleDtt",cattleData)
    const hasEmptyFields = cattleData?.some(
  (cattle) => !cattle.cattle_tag_number || !cattle.cattle_tag_date
);
if(hasEmptyFields){
     swal("Cattle Tag No, Tagging Date are mandatory ", {
            buttons: false,
            icon: "warning",
            title: "Missing Details",
            timer: 1500,
          });
          return;
}

    setLoading(true);
    let sendPayload = {
      first_name: leadDataEdit.first_name,
      last_name: leadDataEdit.last_name,
      lead_source: leadDataEdit.lead_source,
      primary_occupation: leadDataEdit.primary_occupation,
      // phone_number: leadDataEdit.phone_number,

      type: leadDataEdit.type,
      DOB: leadDataEdit.DOB.split("-")
        .reverse()
        .join("-"),
      gender: leadDataEdit.gender,

      ...(residentialPinState === "Pincode" && {
        state_name: PincodeDataList.State,
        district_name: PincodeDataList.District,
        block_name: PincodeDataList.Block,
        pincode: PincodeValue,
        address: leadDataEdit.address,
      }),
      ...(residentialPinState === "StateLevel" && {
        state_name: stateNameEdit,
        state_code: stateIdEdit,
        district_name: districtNameEdit,
        district_code: districtIdEdit,
        block_code: blockIdEdit,
        block_name: blockNameEdit,
        address: leadDataEdit.address,
        pincode: "",
        location: "",
      }),
      // lead_details: updatedLeadDetails,
      lead_details: updatedLeadDetail(cattleData),
    };
    const farmerPayload = {
      first_name: leadDataEdit.first_name,
      last_name: leadDataEdit.last_name,
      farmer_category: "",
      DOB:
        leadDataEdit?.DOB?.split("-")[0].length === 4
          ? leadDataEdit?.DOB.split("-")
              .reverse()
              .join("-")
          : leadDataEdit?.DOB,
      age: leadDataEdit.age,
      gender: leadDataEdit.gender,
      state_name: stateNameEdit,
      state_code: stateIdEdit,
      district_name: districtNameEdit,
      district_code: districtIdEdit,
      block_code: blockIdEdit,
      block_name: blockNameEdit,
      address: leadDataEdit.address,
    };

    updateCrmLead({ id: LeadsDataHalf.id, payload: sendPayload })
      .unwrap()
      .then((data) => {
        if (data.success) {

          if (leadDetails.allData.user_id) {
            updateFarmer({
              id: leadDetails.allData.user_id,
              payload: farmerPayload,
            })
              .unwrap()
              .then((data) => {
                if (data.success) {
                  console.log("updating success");
                } else {
                }
              });
          }

          swal("Lead Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Lead Updated",
            timer: 1500,
          });
          // setLeadEditModal(false);
          setLoading(false);
          refetch();
          refetchLeadsData(LeadsDataHalf.id);
          hideLeadEditModal();
          setDetailsModal(false);
          setLeadDataEdit({
            first_name: "",
            last_name: "",
            lead_source: "",
            primary_occupation: "",
            phone_number: "",
            DOB: "",
            gender: "",
            service_name: "Insurance",
            product_name: "",
            product_value: "",
            pincode: "",
            type: "",
          });
        } else {
          swal("Oops", {
            buttons: false,
            icon: "success",
            title: "Something went wrong !!!",
            timer: 1500,
          });
          setLoading(false);
        }
      });
  };

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };

  const onLocationChangeEdit = (event) => {
    if (event.ConditionName == "state") {
      setBlockIdEdit("");
      setDistrictNameEdit("");
      setDistrictIdEdit("");
      setBlockNameEdit("");
      setBlockList([]);
      setStateIdEdit(event.value);
      setStateNameEdit(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictIdEdit(event.value);
      setDistrictNameEdit(event.label);
      setBlockIdEdit("");
      setBlockNameEdit("");
    }
    if (event.ConditionName == "block") {
      setBlockIdEdit(event.value);
      setBlockNameEdit(event.label);
    }
  };
  useEffect(() => {
    if (dataDistrict !== undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock !== undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  // const customStyles2 = {
  //   control: (base) => ({
  //     ...base,
  //     height: 40,
  //     minHeight: 40,
  //   }),
  // };
   const customStyles2 = {
    control: (provided) => ({
      ...provided,
      minHeight: "45px",
      height: "45px",
      padding: "0px",
      fontSize: "13px",
      // zIndex:100
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 8px",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "12px",
    }),
  };
  const [localFiles, setLocalFiles] = useState({});
  const [kycFiles, setKycFiles] = useState({});
  const [kycType, setKycType] = useState("");

  const [proposalFile, setProposalFile] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({
    paymentId: "",
    amount: "",
    remark: "",
    receiptFile: null,
  });
  function generateCattleId() {
    return "CATIB" + Math.floor(100000 + Math.random() * 900000);
    // const generateCattleId = () => "cattle_" + Date.now() + "_" + Math.random().toString(36).substr(2, 5);

  }

  useEffect(() => {
    if(Isproposal){
  if (cattleAddedDetails && cattleAddedDetails.length > 0) {
    setCattleData((prev) => {
     
      const existingIds = new Set(prev.map((c) => c.cattle_id));
      const merged = [
        ...prev,
        ...cattleAddedDetails.filter((c) => !existingIds.has(c.cattle_id)),
      ];


      return merged;
    });
  } else {
    setCattleData((prev) =>
      prev.length === 0
        ? [
            {
              cattle_id: generateCattleId(),
              cattle_tag_number: "",
              cattle_tag_date: "",
              name: leadDataEdit?.first_name,
            },
          ]
        : prev
    );
  }
}
else{
    if (cattleAddedDetails && cattleAddedDetails.length > 0) {
      setCattleData(cattleAddedDetails);
    } else {
      setCattleData([
        {
          cattle_id: generateCattleId(),
          cattle_tag_number: "",
          cattle_tag_date: "",
          name: leadDataEdit?.first_name,
        },
      ]);
    }
}
}, [cattleAddedDetails,leadDataEdit]);

  const removeCattleRow = async (index) => {
    const updated = [...cattleData];
    // updated.splice(index, 1);
  const removedCattle = updated.splice(index, 1)[0]; // capture removed cattle
    const newCattlePayload =
      updated.length > 0
        ? updated
        : [
            {
              cattle_id: generateCattleId(),
              cattle_tag_number: "",
              cattle_tag_date: "",
              name: leadDataEdit?.first_name,
            },
          ];
    setCattleData(newCattlePayload);
     setLocalFiles((prev) => {
    const newFiles = { ...prev };
    delete newFiles[removedCattle.cattle_id];
    return newFiles;
  });
    // const sendPayload = {
    //   lead_details: updatedLeadDetail(newCattlePayload),
    // };
    // await updateCrmLead({
    //   id: LeadsDataHalf.id,
    //   payload: sendPayload,
    // }).unwrap();
    // refetchLeadsData(LeadsDataHalf.id);
  };
  // Handle cattle info changes
  const handleCattleChange = (index, field, value) => {
    if (field === "cattle_tag_number") {
      value = value.toUpperCase();
    }
    const updated = [...cattleData];

    updated[index] = {
      ...updated[index],
      [field]: value,
      name: leadDataEdit?.first_name,
    };

    setCattleData(updated);
  };

 
  const addCattleRow = () => {
    const newRow = {
      cattle_id: generateCattleId(),
      cattle_tag_number: "",
      cattle_tag_date: "",
      name: leadDataEdit?.first_name,
    };

    setCattleData([newRow, ...cattleData]);
  };


  const handlePaymentChange = (field, value) => {
    setPaymentDetails((prev) => ({ ...prev, [field]: value }));
  };

  const handlePaymentFile = (file) => {
    setPaymentDetails((prev) => ({ ...prev, receiptFile: file }));
  };

  // console.log("proposalUploaded", proposalUploaded);
  const [paymentUploading, setpaymentUploading] = useState(false);

  const handlePaymentSubmit = async () => {
    if (
      !paymentDetails.receiptFile ||
      !paymentDetails.remark?.trim() ||
      !paymentDetails.amount ||
      !paymentDetails.paymentId?.trim()
    ) {
      swal("Please fill all required details.", {
        buttons: false,
        icon: "warning",
        title: "Missing Fields",
        timer: 1500,
      });
      return;
    }

    setpaymentUploading(true);

    const formData = new FormData();
    formData.append("media_type", "Cattle Insurance Payment");
    formData.append("media_category", "Payment Detail");
    formData.append("entity_id", LeadsDataHalf?.id);
    formData.append("file_type", "Payment Detail");
    formData.append("filename", "Payment File");
    formData.append("files", paymentDetails.receiptFile);
    formData.append("remark", paymentDetails.remark);
    formData.append("amount", paymentDetails.amount);
    formData.append("payment_id", paymentDetails.paymentId);

    try {
      const mediaResponse = await uploadMedia({
        id: LeadsDataHalf.user_id,
        formData,
      }).unwrap();


      const sendPayload = {
        current_status: "Payment Submitted",
        current_remarks: "Payment Submitted",

        cattle_ins_gen_form: {
          amount: paymentDetails.amount,
          paymentId: paymentDetails.paymentId,
          remark: paymentDetails.remark,
        },
      };

      await updateCrmLead({
        id: LeadsDataHalf.id,
        payload: sendPayload,
      }).unwrap();
      setIsProposal(true)
      toast.success("Payment document uploaded successfully!");
      setPaymentDetails({});
      refetchDocuments();
    refetchLeadsData(LeadsDataHalf.id);
      refetch();
      setpaymentUploading(false);
    } catch (err) {
      console.error("Error while uploading payment:", err);
    } finally {
      setpaymentUploading(false);
    }
  };


  const convertToTitleCase = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  const getTypeFromPath = (p) => {
    if (!p) return "image";
    const lower = p.toLowerCase();
    if (lower.endsWith(".pdf")) return "pdf";
    if (lower.endsWith(".mp4")) return "mp4";
    if (/\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(lower)) return "image";
    return "image";
  };
  const openInNewTab = async (URL) => {
    const res = await fetch(URL);
    const uint8arr = new Uint8Array(await new Response(res.body).arrayBuffer());

    const link = document.createElement("a");
    const blob = new Blob([uint8arr], { type: "application/pdf" });

    link.target = "_blank";
    link.href = window.URL.createObjectURL(blob);
    link.click();
  };

  const refetchPreAssigned = async (path, type) => {
    const state = store.getState();
    try {
      const pathImageCattle = await axios.get(
        `${API_URL}/api/v1/onboarding/media/get_file?path=${path}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!pathImageCattle?.data?.data?.url) return;
      const url = pathImageCattle?.data?.data?.url;
      if (type === "image") {
        setImageInLightbox(url);
        setOpenLightBox(true);
      } else if (type === "pdf") {
        openInNewTab(url);
      } else if (type === "mp4") {
        setOverlayUrl(url);
        setOverlayOpen(true);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };
  const handleDocClick = (doc) => {
    if (!doc?.path) return;
    const type = getTypeFromPath(doc.path);
    setMediaType(type);
    refetchPreAssigned(doc.path, type);
  };

  // Inside your component
  const renderDocThumbnail = (doc) => {
    const placeholder =
      doc.file_type === "image"
        ? doc.path // show actual image if available
        : doc.file_type === "pdf"
        ? "/pdf-icon.png" // use your PDF icon path
        : doc.file_type === "video"
        ? "/video-icon.png" // use your video icon path
        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s";

    return (
      <div
        key={doc.id}
        className="text-center"
        style={{ width: 120, cursor: "pointer", flexShrink: 0 }}
        onClick={() => handleDocClick(doc)}
      >
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: 4,
            background: "#fff",
            transition: "all 0.2s ease-in-out",
          }}
          className="hover-shadow"
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
            alt={
              doc?.media_type ? convertToTitleCase(doc.media_type) : "Document"
            }
            width="100"
            height="60"
            style={{
              objectFit: "cover",
              borderRadius: 4,
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <div
          style={{
            marginTop: 6,
            fontSize: 13,
            fontWeight: 500,
            color: "#444",
            textAlign: "center",
            wordBreak: "break-word",
          }}
          title={doc?.media_type ? convertToTitleCase(doc.media_type) : ""}
        >
          {doc?.media_type ? convertToTitleCase(doc.media_type) : "Document"}
        </div>
      </div>
    );
  };
  const handleUploadAll = async () => {
    setSpinner(true);

    const uploads = [];

    const uploadDoc = async (section, file, mediaType, mediaCategory) => {
      const formData = new FormData();
      formData.append("media_type", mediaType);
      formData.append("media_category", mediaCategory);
      formData.append(
        "entity_id",
        mediaCategory === "Proposal Form"
          ? LeadsDataHalf?.id
          : LeadsDataHalf?.user_id
      );
      formData.append("file_type", mediaType);
      formData.append("filename", mediaCategory);
      formData.append("files", file);

      return uploadMedia({ id: LeadsDataHalf.user_id, formData }).unwrap();
    };

    try {
      if (kycFiles.aadhaar)
        uploads.push(
          uploadDoc("KYC", kycFiles.aadhaar, "aadhaar", "KYC Documents")
        );

      if (kycFiles.pan)
        uploads.push(uploadDoc("KYC", kycFiles.pan, "pan", "KYC Documents"));

      if (kycFiles.photograph)
        uploads.push(
          uploadDoc("KYC", kycFiles.photograph, "photograph", "KYC Documents")
        );

      // 🧩 Proposal Form upload
      if (proposalFile) {
        // uploadDoc returns a promise, we wait for it first
        const proposalResponse = await uploadDoc(
          "Proposal Form",
          proposalFile,
          "Proposal Form",
          "Proposal Form"
        );


        const sendPayload = {
          first_name: leadDataEdit.first_name,
          last_name: leadDataEdit.last_name,
          current_status: "Proposal Form Submitted",
          current_remarks: "Proposal Form Submitted",

        };
      setIsProposal(true)
        await updateCrmLead({
          id: LeadsDataHalf.id,
          payload: sendPayload,
        }).unwrap();

        // toast.success("Proposal form uploaded and lead updated successfully!");
        
        refetchLeadsData(LeadsDataHalf.id);
        refetch();
      }

      // await Promise.all(uploads);

      // toast.success("All selected documents uploaded successfully!");
      // setSpinner(false);
      // setKycFiles({});
      // setProposalFile(null);
      // refetchDocuments();
      // refetch()
      try {
        await Promise.all(uploads);

        toast.success("Documents uploaded successfully!");

        await Promise.all([
          // refetchLeadsData(LeadsDataHalf.id)?.(),
          refetchDocuments?.(),
        ]);

        setKycFiles({});
        setProposalFile(null);
      } catch (err) {
        console.error("Error uploading:", err);
      } finally {
        setSpinner(false);
      }
    } catch (err) {
      toast.error("Error uploading one or more documents");
      setSpinner(false);
    }
  };
  const normalizeDocType = (type) => {
  if (!type) return "";
  return type
    .toLowerCase()
    .replace(/\s+/g, "")       
    .replace("card", "")       
    .trim();                  
};

  const renderUploadCard = (type, uploadedList, setFileState) => {

    let isUploaded = false;
    if (type === "proposal form") {
      isUploaded = Array.isArray(uploadedList) && uploadedList.length > 0;
    } else {
      isUploaded = Array.isArray(uploadedList)
        ? uploadedList.some(
            (d) =>
              // d.document_type?.toLowerCase() === type.toLowerCase() &&
              normalizeDocType(d.document_type) === normalizeDocType(type) &&

              d.documents?.length > 0
          )
        : false;
    }

    const label =
      type === "aadhaar"
        ? "Aadhaar Card"
        : type === "pan"
        ? "PAN Card"
        : type === "photograph"
        ? "Photograph"
        : "Proposal Form";

    if (isUploaded) return null; // ✅ hide upload if already uploaded

    // get the file currently selected for this type
    const selectedFile =
      type === "proposal form" ? proposalFile : kycFiles?.[type] || null;
    const handleFileSelect = (file) => {
      if (!file) return;
      if (type === "proposal form") {
        setProposalFile(file);
      } else {
        setKycFiles((prev) => ({
          ...prev,
          [type]: file,
        }));
      }
    };
    return (
      <div className="flex flex-col">
      <div
        key={type}
        // className="d-flex flex-column align-items-center justify-content-center border rounded p-3"
        className="border rounded-2 p-3 shadow-sm d-flex flex-column align-items-center justify-content-center"
        style={{
          width: "130px",
          height: "80px",
          background: "#fff",
          cursor: "pointer",
          transition: "0.3s ease",
        }}
        onClick={() => document.getElementById(`upload-${type}`).click()}
        onDragOver={(e) => e.preventDefault()} // 👈 Prevent default browser behavior
        onDrop={(e) => {
          e.preventDefault();
          const file = e.dataTransfer.files?.[0];
          handleFileSelect(file);
        }}
      >
         <i className="mdi mdi-upload text-orange" style={{fontSize:"18px"}}></i> 
        

        <div
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: "#444",
            textAlign: "center",
            marginBottom:"7px"
           
          }}
        >
          {label}
        </div>
        {/* ✅ Show selected filename */}
        {/* {selectedFile && (
          <div
            className="text-success mt-2 text-center"
            style={{ fontSize: 12, maxWidth: "100%", wordBreak: "break-word" }}
          >
            {selectedFile.name?.length > 18
              ? selectedFile.name.slice(0, 18) + "..."
              : selectedFile.name}
          </div>
        )} */}

        <input
          type="file"
          id={`upload-${type}`}
          style={{ display: "none" }}
          accept={type === "photograph" ? "image/*" : ".pdf,.jpg,.jpeg,.png"}
        
          onChange={(e) => handleFileSelect(e.target.files?.[0])}
        />
      </div>
        {selectedFile && (
          <div
            className="text-success mt-2 text-center"
            style={{ fontSize: 12, maxWidth: "100%", wordBreak: "break-word" }}
          >
            {selectedFile.name?.length > 18
              ? selectedFile.name.slice(0, 18) + "..."
              : selectedFile.name}
          </div>
        )}
      </div>
    );
  };

  const renderCattleUploadCard = (cattle, type, index) => {
 
    const uploadedTypes = cattleUploaded
      ?.filter((doc) =>
        doc.documents.some(
          (d) =>
            d.entity_id?.toLowerCase() === cattle.cattle_tag_number?.toLowerCase() + "_" + cattle.cattle_id?.toLowerCase()
        )
      )
      ?.map((d) => d.document_type);

    const isUploaded =
    uploadedTypes?.includes(type) 
    // ||
    // (type === "Health Certificate" && cattle?.cattle_health_certificate)
    ;

    const selectedFile = localFiles[cattle.cattle_id]?.[type] || null;
   

    if (isUploaded) return null;
  
    const handleFileSelect = (file) => {
      if (!file) return;

      const MAX_SIZE_MB = 30;
      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > MAX_SIZE_MB) {
        toast.error(`File size exceeds ${MAX_SIZE_MB} MB limit.`);
        return;
      }

      if (file.type.startsWith("video/")) {
        const validTypes = ["video/mp4", "video/webm", "video/ogg"];
        if (!validTypes.includes(file.type)) {
          toast.error("Only MP4, WEBM, or OGG videos are allowed.");
          return;
        }

        const video = document.createElement("video");
        video.preload = "metadata";
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src);
          if (video.duration > 60) {
            toast.error("Video duration must be less than 60 seconds.");
            return;
          }
          saveFile();
        };
        video.src = URL.createObjectURL(file);
      } else {
        saveFile();
      }

      function saveFile() {
        setLocalFiles((prev) => ({
          ...prev,
          // [index]: { ...prev[index], [type]: file },
          [cattle.cattle_id]: { ...prev[cattle.cattle_id], [type]: file },

        }));
      }
    };

    return (
      <div className="flex flex-col">
      <div
        key={type}
        className="border rounded-2 p-3 shadow-sm d-flex flex-column align-items-center justify-content-center"
        style={{
          width: "130px",
          height: "80px",
          background: "#fff",
          cursor: "pointer",
          transition: "0.3s ease",
        }}
        onClick={() =>
          document.getElementById(`cattle-upload-${cattle.cattle_id}-${type}`).click()
        }
        onDragOver={(e) => e.preventDefault()} // 👈 Prevent default browser behavior
        onDrop={(e) => {
          e.preventDefault();
          const file = e.dataTransfer.files?.[0];
          handleFileSelect(file);
        }}
      >
        <i className="mdi mdi-upload text-orange" style={{fontSize:"18px"}}></i>
       
        <div
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: "#444",
            textAlign: "center",
            marginBottom:"7px"
          }}
        >
          {type}
        </div>

        {/* Selected file */}
       

        <input
          type="file"
            id={`cattle-upload-${cattle.cattle_id}-${type}`} // unique
                key={`file-${cattle.cattle_id}-${type}`} // React key

          style={{ display: "none" }}
          accept={
            type === "Cattle Image"
              ? "image/*"
              : type === "Cattle Video"
              ? "video/*"
              // : ".pdf,.jpg,.jpeg,.png"
              : ".pdf"

          }
         
          onChange={(e) => handleFileSelect(e.target.files?.[0])}
        />
      </div>
       {selectedFile && (
          <div
            className="text-success mt-2 text-center"
            style={{ fontSize: 12, maxWidth: "100%", wordBreak: "break-word" }}
          >
            {selectedFile.name?.length > 18
              ? selectedFile.name.slice(0, 12) + "..."
              : selectedFile.name}
          </div>
        )}
      </div>
    );
  };
  const[selectedIndex,setSelectedIndex]=useState("")
  const [cattleLoader, setCattleLoader] = useState(false);
  const handleCattleUploadAll = async (cattleId,index) => {
    const cattle = cattleData[index];
    const filesForCattle = localFiles[cattleId];
    if (
      !cattle.cattle_tag_number ||
      !cattle.cattle_id ||
      !cattle.cattle_tag_date
    ) {
      swal("Please fill Cattle Tag Number, and Date before uploading.", {
        buttons: false,
        icon: "warning",
        title: "Missing Fields",
        timer: 1500,
      });
      return;
    }

    if (!filesForCattle || Object.keys(filesForCattle).length === 0) {
      swal("Please select at least one file to upload.", {
        buttons: false,
        icon: "warning",
        title: "Missing Fields",
        timer: 1500,
      });
      return;
    }

    setCattleLoader(true);
    setSelectedIndex(index)

    try {
      for (const type in filesForCattle) {
        const file = filesForCattle[type];
        const formData = new FormData();
        formData.append("media_type", type);
        formData.append("media_category", "Cattle Documents");
        formData.append(
          "entity_id",
          cattle.cattle_tag_number + "_" + cattle.cattle_id
        );

        const fileType = file.type.includes("image")
          ? "Cattle Photographs"
          : file.type.includes("pdf")
          ? "Health Certificate"
          : "Cattle Video";

        formData.append("file_type", fileType);
        formData.append("filename", fileType);
        formData.append("files", file);

        await uploadMedia({ id: LeadsDataHalf.user_id, formData }).unwrap();
        const sendPayload = {
          lead_details: updatedSingleCattle(cattle),
        };
        // console.log("sendPayload",sendPayload)
        setIsProposal(true)
        await updateCrmLead({
          id: LeadsDataHalf.id,
          payload: sendPayload,
        }).unwrap();
        refetchLeadsData(LeadsDataHalf.id);
      }

      toast.success("All selected documents uploaded successfully!");

      // ✅ Safe immutable updates
      // setLocalFiles({ ...localFiles, [index]: {} });
     setLocalFiles((prev) => ({
      ...prev,
      [cattleId]: {},
    }));

      setCattleData((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index] };
        return updated;
      });
      setCattleLoader(false);
         setSelectedIndex("")

      refetchDocuments();
    } catch (err) {
      console.error(err);
      toast.error("Error uploading documents");
    } finally {
      setCattleLoader(false);
    }
  };

  // const filteredPayments =
  //   paymentUploaded?.documents?.filter(
  //     (doc) => doc.entity_id === LeadsDataHalf.id
  //   ) ?? [];
 const filteredPayments =
  paymentUploaded?.flatMap((docCategory) =>
    docCategory?.documents
      ?.filter((doc) => doc.entity_id === LeadsDataHalf?.id)
      ?.map((doc) => ({
        ...doc,
        document_type: docCategory.document_type, // preserve parent category name
      }))
  ) ?? [];

  const filteredProposal = proposalUploaded?.filter(
    (doc) => doc.entity_id === LeadsDataHalf.id
  );

  return (
    <div className="formdetails">
      <form onSubmit={onSubmitLeadEditData}>
        <div className="row">
          <div className="col-lg-2 form-group mb-2 text_box">
            {/* <Label className="f_p text_c f_400">
              First Name <small className="text-danger">*</small>
            </Label>
            <input
              name="first_name"
              type="text"
              className="form-control fs-6"
              placeholder="Enter First Name"
              required
              value={leadDataEdit.first_name}
              onChange={handleChangeEditLead}
            /> */}
            <CustomTextField
                type="text"
                name="first_name"
               value={leadDataEdit.first_name}
              onChange={handleChangeEditLead}
                required
              />
          </div>
          <div className="col-lg-2 form-group mb-2 text_box">
            {/* <Label className="f_p text_c f_400">Last Name</Label>
            <input
              className="form-control fs-6"
              type="text"
              placeholder="Enter Last Name"
              name="last_name"
              value={leadDataEdit.last_name}
              onChange={handleChangeEditLead}
            /> */}
              <CustomTextField
                type="text"
                placeholder="Enter Last Name"
              name="last_name"
              value={leadDataEdit.last_name}
              onChange={handleChangeEditLead}
                
              />
          </div>

          <div className="col-lg-2 form-group mb-2 text_box ">
            {/* <Label className="f_p text_c f_400">
              Phone Number 
            </Label>
            <input
              name="phone_number"
              type="text"
              pattern="^[0-9\b]+$"
              className="form-control fs-6"
              placeholder="Enter 10 digit Number"
              minLength="10"
              maxLength="10"
              required
              disabled
              value={leadDataEdit.phone_number}
              onChange={handleChangeEditLead}
            /> */}
             <CustomTextField
                type="text"
                name="phone_number"
             disabled
              value={leadDataEdit.phone_number}
                
              />
          </div>

          <div className="col-lg-2 form-group mb-2 text_box">
            <Label className="f_p text_c f_400">
              DOB<small className="text-danger">*</small>
            </Label>
            <input
              name="DOB"
              type="date"
              className="form-control fs-6"
              placeholder="Enter DOB"
              required
              value={leadDataEdit.DOB}
              onChange={handleChangeEditLead}
              style={{height:"43px"}}
            />
             {/* <CustomTextField
              name="DOB"
                type="date"
               required
              value={leadDataEdit.DOB}
              onChange={handleChangeEditLead}
                
              /> */}
          </div>
          <div className="col-lg-2 form-group mb-2 text_box">
            <Label className="f_p text_c f_400">
              Gender <small className="text-danger">*</small>
            </Label>
            <select
              name="gender"
              style={{ padding: "15px",height:"43px" }}
              className="form-control fs-6"
              required
              value={leadDataEdit.gender}
              onChange={handleChangeEditLead}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Others</option>
            </select>
          </div>
          <div className="col-lg-2 form-group mb-2 text_box">
            <Label className="f_p text_c f_400">
              Primary Occupation
              <small className="text-danger">*</small>
            </Label>
            <select
              className="form-control fs-6"
              name="primary_occupation"
              style={{ padding: "15px",height:"45px" }}
              required
              value={leadDataEdit.primary_occupation}
              onChange={handleChangeEditLead}
            >
              <option value="">Select</option>
              <option value="Agriculture">Agriculture</option>
              <option value="Trader">Trader</option>
              <option value="Public Sector">Public Sector</option>
              <option value="Private Sector">Private Sector</option>
              <option value="Dairy Farmer">Dairy Farmer</option>
              <option value="Others">Others</option>
            </select>
          </div>
          {/* <Row className="mt-2">
            <Col lg="5" className="">
              <label>
                <b> Details Based on</b>
              </label>
              <FormGroup className="mt-2">
                <div className="d-flex flex-row">
                  <Label className="d-flex align-items-center">
                    <Input
                      type="radio"
                      name="home"
                      value="Pincode"
                      checked={residentialPinState === "Pincode"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">Pincode</span>
                  </Label>
                  <Label className="d-flex align-items-center mt-1 mx-5">
                    <Input
                      type="radio"
                      name="home"
                      value="StateLevel"
                      checked={residentialPinState === "StateLevel"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">
                      Based on State, District, Block
                    </span>
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row> */}
          {/* {residentialPinState === "Pincode" ? (
            <Row className="text-gray mt-2">
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="number"
                  name="pincode"
                  value={PincodeValue}
                  onChange={handlePinCodeChange}
                  maxLength="6"
                  placeholder="Pincode"
                  required
                />
                {PincodeValue.length > 6 || pincodeError ? (
                  <div className="text-danger mt-1">Enter a valid pincode</div>
                ) : null}
              </Col>

              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="State"
                  value={PincodeDataList.State}
                  disabled
                  placeholder="State"
                />
              </Col>
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="District"
                  value={PincodeDataList.District}
                  disabled
                  placeholder="District"
                />
              </Col>
              <Col lg="3" className="mb-4">
                <CustomTextField
                  type="text"
                  name="Block"
                  value={PincodeDataList.Block}
                  disabled
                  placeholder="Block"
                />
              </Col>

              <Col lg="8" className="mb-4">
                <CustomTextField
                  type="text"
                  name="address"
                  value={leadDataEdit.address}
                  onChange={handleChangeEditLead}
                  placeholder="Full Address"
                  required
                />
              </Col>
            </Row>
          ) : residentialPinState === "StateLevel" ? ( */}
          {/* <h5 className="mt-1">Location Details</h5> */}
        
          <Row className="text-gray mt-2">
            <Col lg="2" className="mb-4">
              <label className="text-black"> State</label>
              <Select
                menuPlacement="auto"
                options={handleStateOptions()}
                placeholder={
                stateNameEdit
                }
                value={!stateIdEdit ? "Select State" : stateNameEdit}
                onChange={onLocationChangeEdit}
                styles={customStyles2}
                isLoading={loadingStateOptions}
                className="mt-2"
              />
            </Col>
            <Col lg="2" className="mb-4">
              <label className="text-black"> District</label>
              <Select
                menuPlacement="auto"
                options={handleDistrictOptions()}
                placeholder={
                  districtNameEdit === "" ? "Select District" : districtNameEdit
                }
                value={
                  districtNameEdit === "" ? "Select District" : districtNameEdit
                }
                onChange={onLocationChangeEdit}
                styles={customStyles2}
                isLoading={loadingDistrictOptions}
                className="mt-2"
              />
            </Col>
            <Col lg="2" className="mb-4">
              <label className="text-black"> Block</label>
              <Select
                menuPlacement="auto"
                options={handleBlockOptions()}
                placeholder={
                  blockNameEdit == "" ? "Select Block" : blockNameEdit
                }
                value={blockNameEdit === "" ? "Select Block" : blockNameEdit}
                onChange={onLocationChangeEdit}
                styles={customStyles2}
                className="mt-2"
              />
            </Col>

            <Col lg="6" className="mb-4">
              <CustomTextField
                type="text"
                name="address"
                value={leadDataEdit.address}
                onChange={handleChangeEditLead}
                required
              />
            </Col>
          </Row>
          {/* ) : (
            ""
          )} */}
        </div>
     
        <div className="row">
          <div className="col-12">
            <h5 className="mt-4 fw-semibold">KYC & Proposal Documents</h5>
            <i
              className="text-warning"
              style={{
                fontSize: "0.8rem",
                fontWeight: "400",
                marginTop: "-10px",
              }}
            >
             Once the proposal form is submitted, you cannot add or remove cattle.
            </i>
            {console.log("kycUploaded",kycUploaded)}
            <div
              className="p-3 border rounded shadow-sm mt-3"
              style={{ background: "#fafafa" }}
            >
              <div className="d-flex flex-wrap gap-3 mb-3" style={{ width: "100%" }}>
              <div className="d-flex flex-wrap gap-3 mb-3">
                {kycUploaded?.map((d) =>
                  d.documents.map((doc) => renderDocThumbnail(doc))
                )}
                {filteredProposal?.map((doc) => renderDocThumbnail(doc))}
              </div>

            
              <div className="d-flex flex-wrap gap-3">
                {renderUploadCard("aadhaar", kycUploaded, setKycFiles)}
                {renderUploadCard("pan", kycUploaded, setKycFiles)}
                {renderUploadCard("photograph", kycUploaded, setKycFiles)}
                {renderUploadCard(
                  "proposal form",
                  filteredProposal,
                  setProposalFile
                )}
              </div>
              </div>

              {(!kycUploaded?.some(
                (d) => d.document_type?.toLowerCase() === "aadhaar"
              ) ||
                kycFiles.aadhaar ||
                !kycUploaded?.some(
                  (d) => d.document_type?.toLowerCase() === "pan"
                ) ||
                kycFiles.pan ||
                !kycUploaded?.some(
                  (d) => d.document_type?.toLowerCase() === "photograph"
                ) ||
                kycFiles.photograph ||
                filteredProposal?.length === 0 ||
                proposalFile) && (
                <div className="text-end mt-3">
                  <Button
                    className="buttonOrangeDefaultColor2"
                    disabled={
                      !kycFiles.aadhaar &&
                      !kycFiles.pan &&
                      !kycFiles.photograph &&
                      !proposalFile
                    }
                    onClick={handleUploadAll}
                  >
                    {(kycFiles || proposalFile) && showSpinner ? (
                      <>
                        Uploading... &nbsp; <Spinner size="sm" />
                      </>
                    ) : (
                      "Upload"
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>

        <>
          <h5 className="mt-3 d-flex justify-content-between align-items-center">
            <span>Cattle Details</span>

            {!LeadsDataHalf?.status_list?.includes(
              "Proposal Form Submitted"
            ) && (
              <Button
                type="button"
                color="primary"
                className="d-flex align-items-center gap-1 shadow-sm"
                style={{ borderRadius: "10px", fontWeight: "500" }}
                onClick={addCattleRow}
              >
                <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i> Add
                Cattle
              </Button>
            )}
          </h5>
          <i
            className="text-warning"
            style={{
              fontSize: "0.8rem",
              fontWeight: "400",
              marginTop: "-10px",
            }}
          >
           Editing of cattle tag no and date is disabled after document upload.
          </i>

          {cattleData.map((cattle, index) => {
            const availableTypes = [
              "Health Certificate",
              "Cattle Image",
              "Cattle Video",
            ];

            // Check which types are already uploaded
            const uploadedTypes = cattleUploaded
              ?.filter((doc) =>
                doc.documents.some(
                  (d) =>
                    d.entity_id?.toLowerCase() ===
                    cattle.cattle_tag_number?.toLowerCase() + "_" + cattle.cattle_id?.toLowerCase()
                )
              )
              ?.map((d) => d.document_type);
              // if (cattle?.cattle_health_certificate && !uploadedTypes?.includes("Health Certificate")) {
              //      uploadedTypes?.push("Health Certificate");
              //     }

            const hasPendingUploads = availableTypes?.some(
              (type) =>
                  !uploadedTypes?.includes(type) && localFiles[cattle.cattle_id]?.[type]

            );
         
            return (
              <div
                key={index}
                className="p-3 border rounded shadow-sm mt-3"
                style={{ background: "#fafafa" }}
              >
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Cattle Tag No.
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      placeholder="Enter Cattle Tag No."
                      value={cattle.cattle_tag_number}
                      disabled={uploadedTypes?.length > 0 ? true : false}
                      onChange={(e) =>
                        handleCattleChange(
                          index,
                          "cattle_tag_number",
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Cattle Tagging Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={formatToYYYYMMDD(cattle.cattle_tag_date)}
                      disabled={uploadedTypes?.length > 0 ? true : false}
                      onChange={(e) =>
                        handleCattleChange(
                          index,
                          "cattle_tag_date",
                          e.target.value
                        )
                      }
                      style={{ height: "43px" }}
                    />
                  </div>
                  {!LeadsDataHalf?.status_list?.includes(
                    "Proposal Form Submitted"
                  ) && (
                    <div className="col-md-2 offset-md-1">

                      <Button
                        size="sm"    
                         className="btn btn-danger waves-effect mt-4" 
                        onClick={() => removeCattleRow(index)}
                      >
                        <i className="mdi mdi-trash-can custom-btn-fs fs-6"></i>{" "}
                        Remove
                      </Button>
                    </div>
                  )}
                </div>
                                <div className="d-flex flex-wrap gap-3 mb-3" style={{ width: "100%" }}>

                <div className="d-flex flex-wrap gap-3 mt-3">
                  {availableTypes.map((type) =>
                    renderCattleUploadCard(cattle, type, index)
                  )}
                </div>

                <div className="d-flex flex-wrap gap-2 mt-3">
                  {cattleUploaded
                    ?.filter((doc) =>
                      doc.documents.some(
                        (d) =>
                          d.entity_id?.toLowerCase() ===
                          cattle.cattle_tag_number?.toLowerCase() + "_" + cattle.cattle_id?.toLowerCase()
                      )
                    )
                    .map((doc) =>
                      doc.documents
                        .filter(
                          (d) =>
                            d.entity_id?.toLowerCase() ===
                            cattle.cattle_tag_number?.toLowerCase() + "_" + cattle.cattle_id?.toLowerCase()
                        )
                        .map((d) => (
                          <div key={d.id}>{renderDocThumbnail(d)}</div>
                        ))
                    )}
                    {/* {cattle?.cattle_health_certificate&&
                     <div
        key={cattle.cattle_tag_number}
        className="text-center"
        style={{ width: 120, cursor: "pointer", flexShrink: 0 }}
          onClick={() => {
                                if (
                                  cattle?.cattle_health_certificate.startsWith(
                                    "http://"
                                  ) ||
                                  cattle?.cattle_health_certificate.startsWith(
                                    "https://"
                                  )
                                ) {
                                  window.open(
                                    cattle?.cattle_health_certificate,
                                    "_blank",
                                    "noopener,noreferrer"
                                  );
                                } else {
                                  handleDocClick(
                                    cattle?.cattle_health_certificate
                                  );
                                }
                              }}
      >
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: 4,
            background: "#fff",
            transition: "all 0.2s ease-in-out",
          }}
          className="hover-shadow"
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
            alt={
              "Health Certificate"
            }
            width="100"
            height="60"
            style={{
              objectFit: "cover",
              borderRadius: 4,
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <div
          style={{
            marginTop: 6,
            fontSize: 13,
            fontWeight: 500,
            color: "#444",
            textAlign: "center",
            wordBreak: "break-word",
          }}
          title="Health Certificate"
        >
         Health Certificate
        </div>
      </div>
                    } */}
                </div>
                </div>
                {hasPendingUploads && (
                  <div className="text-end mt-3">
                    <Button
                      className="buttonOrangeDefaultColor2"
                      disabled={
                     
                        !localFiles[cattle.cattle_id] ||
                          Object.keys(localFiles[cattle.cattle_id] || {}).length === 0

                      }
                      onClick={() => handleCattleUploadAll(cattle.cattle_id,index)}
                    >
                      { index===selectedIndex? (
                        <>
                          Uploading... &nbsp;
                          <Spinner animation="border" size="sm" />
                        </>
                      ) : ( 
                        "Upload"
                       )} 
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </>

        {/* {console.log("paymentUploaded", paymentUploaded)}
        {console.log("filteredPayments", filteredPayments)}
        {console.log("filteredProposal", filteredProposal)}
        {console.log("proposalDocsForUser", proposalUploaded)} */}

        <h5 className="fw-semibold mb-0 me-2 mt-4">Payment Details</h5>
      

        <div className=" gap-2 mb-3 mt-2">
          {filteredPayments?.length > 0 && (
            <div className="row align-items-center">
              <div className="col-4">
                <label className="form-label">Amount</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.amount || ""}
                  disabled
                />
              </div>

              <div className="col-4">
                <label className="form-label">Payment ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.paymentId || ""}
                  disabled
                />
              </div>

              <div className="col-4">
                <label className="form-label">Remark</label>
                <input
                  type="text"
                  className="form-control"
                  value={LeadsDataHalf?.cattle_ins_gen_form?.remark || ""}
                  disabled
                />
              </div>
            </div>
          )}

          {filteredPayments?.map((doc) => (
            <div key={doc.id} className="mt-2">{renderDocThumbnail(doc)}</div>
          ))}
        </div>

        {filteredPayments?.length === 0 && (
          <div
            className="p-3 border rounded shadow-sm "
            style={{ background: "#fafafa" }}
          >
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label fw-semibold">Payment ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={paymentDetails.paymentId}
                  onChange={(e) =>
                    handlePaymentChange("paymentId", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Amount</label>
                <input
                  type="number"
                  className="form-control"
                  value={paymentDetails.amount}
                  onChange={(e) =>
                    handlePaymentChange("amount", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-semibold">Remark</label>
                <input
                  type="text"
                  className="form-control"
                  value={paymentDetails.remark}
                  onChange={(e) =>
                    handlePaymentChange("remark", e.target.value)
                  }
                />
              </div>
            </div>

            <div className="row g-3 align-items-end mt-2">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Payment Receipt
                </label>
                <input
                  type="file"
                  className="form-control"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => handlePaymentFile(e.target.files[0])}
                />
                {/* {paymentDetails.receiptFile && (
      <div className="mt-1 text-success small">
        ✅ {paymentDetails.receiptFile.name}
      </div>
    )} */}
              </div>

              <div className="col-md-3 d-flex justify-content-end">
                {/* <Button
                  type="btn"
                  className="buttonOrangeDefaultColor2"
                  onClick={() => handlePaymentSubmit()}
                >
                  {paymentUploading ? (
                    <>
                      Submitting... &nbsp; <Spinner size="sm" />
                    </>
                  ) : (
                    "Upload"
                  )}
                </Button> */}
                <Button
                  className="buttonOrangeDefaultColor2"
                  disabled={
                    !paymentDetails.receiptFile || !paymentDetails.amount
                    // ||
                    // !paymentDetails.paymentId?.trim()
                  }
                  onClick={handlePaymentSubmit}
                >
                  {paymentUploading ? (
                    <>
                      Submitting... &nbsp; <Spinner size="sm" />
                    </>
                  ) : (
                    "Upload"
                  )}
                </Button>
              </div>
            </div>
          </div>
        )}

        {openLightbox && mediaType === "image" && (
          <Lightbox
            image={lightBoxViewImage}
            title="Image Preview"
            onClose={() => {
              setOpenLightBox(false);
            }}
          />
        )}

        {overlayOpen && mediaType === "mp4" && (
          <div
            className="media-overlay d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.7)",
              zIndex: 2000,
              padding: 20,
            }}
          >
            <div
              style={{
                position: "relative",
                width: "95%",
                maxWidth: 1300,
                height: "90vh",
                background: "#fff",
                borderRadius: 8,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 12px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <div style={{ fontWeight: 600 }}>Video Preview</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Button
                    size="sm"
                    color="danger"
                    onClick={() => {
                      setOverlayOpen(false);
                    }}
                  >
                    Close
                  </Button>
                </div>
              </div>

              <div style={{ flex: 1, minHeight: 0 }}>
                <video
                  src={overlayUrl}
                  controls
                  autoPlay
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    background: "#000",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="col-lg-12 text-center m-auto  mt-4">
          <Button
            className="submit-btn"
            type="submit"
            style={{ float: "right" }}
            disabled={loading ? true : false}
          >
            Submit &nbsp; {loading && <Spinner animation="border" size="sm" />}
          </Button>
        </div>
      </form>
    </div>
  );
};
export default CrmEditLead;
